export const DEFAULT_MAX_API_KEYS = 10;
export const DEFAULT_MAX_CREDENTIAL_CIDR_COUNT = 10;
export const CLIENT_ASSIGNED_NAME_MAX_LENGTH = 255;
